import { FC, PropsWithChildren } from 'react'
import { TenantContextProvider } from './contexts/tenant/TenantContext'
import { TenantFavicon, TenantFaviconType } from './Favicon'
import { TenantAvatar, TenantAvatarType } from './Avatar'

const Tenant: FC<PropsWithChildren> & TenantFaviconType & TenantAvatarType = ({
  children,
}) => <TenantContextProvider>{children}</TenantContextProvider>

Tenant.Favicon = TenantFavicon
Tenant.Avatar = TenantAvatar

export default Tenant
